import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Grid,
    MenuItem,
    TextField,
    Typography,
} from '@mui/material';
import Switch from '@mui/material/Switch';

import React, { useEffect, useState } from 'react';
import { ERROR_MESSAGES, SUCCESS_MESSAGES } from '../../../configs/messages';
import { ROUTES_LIST } from '../../../helpers/routesList';
import showMessage from '../../../helpers/showMessage';
import { useSnackbar } from 'notistack';
import { sendJsonData } from '../../../helpers/sendJsonData';
import { useParams } from 'react-router';
import { useHistory } from 'react-router-dom';
import { deleteData } from '../../../helpers/deleteData';
import { getDataItem } from '../../../helpers/getDataItem';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';

export default function ChannelTypeForm({ isEdit }) {
    const [errors, setErrors] = useState({});
    const [showDeleteValidation, setShowDeleteValidation] = useState(false);
        const [isToggle, setIsToggle] = useState(false)
    const [initialData, setInitialData] = useState({
        name: '',
        description: '',
        active: isToggle
        // vooChannelId: '',
        // channelTypeId: ''
    });

   useEffect(() => {
        setIsToggle(initialData.active);
    }, [initialData.active]);

    const [vooChannelList, setVooChannelList] = useState([]);
    const [channelTypeList, setChannelTypeList] = useState([]);

    const { enqueueSnackbar } = useSnackbar();
    const history = useHistory();
    const { id } = useParams();

    let submitUrl = 'channel/channel-type';
    let vooChannelUrl = 'get/channels';
    let channelTypeUrl = 'channel/channel-types';

    if (isEdit) {
        submitUrl += `/${id}`;
    }
                                                            
    useEffect(() => {
        let isActive = true;

        if (!isEdit) {
            return () => (isActive = false);
        }

        getDataItem(submitUrl)
            .then(({ data }) => {
                if (isActive) {
                    delete data.data?.id;
                    setInitialData(data.data);
                }
            })
            .catch((error) => {
                console.error(error);
                showMessage(
                    error.response?.data?.message
                        ? error.response.data.message     
                        : ERROR_MESSAGES.REQUEST_FAIL,
                    enqueueSnackbar,
                    'error',
                );
            });

        return () => (isActive = false);
    }, [isEdit, submitUrl, enqueueSnackbar]);

    useEffect(() => {
        getDataItem(vooChannelUrl)
            .then(({ data }) => {
                setVooChannelList(data.data);
            })
            .catch((error) => {
                console.error(error);
                showMessage(
                    error.response?.data?.message
                        ? error.response.data.message
                        : ERROR_MESSAGES.REQUEST_FAIL,
                    enqueueSnackbar,
                    'error',
                );
            });
        getDataItem(channelTypeUrl)
            .then(({ data }) => {
                setChannelTypeList(data.data);
            })
            .catch((error) => {
                console.error(error);
                showMessage(
                    error.response?.data?.message
                        ? error.response.data.message
                        : ERROR_MESSAGES.REQUEST_FAIL,
                    enqueueSnackbar,
                    'error',
                );
            });
    }, [enqueueSnackbar]);

    const validate = () => {
        let tempErrors = { ...errors };
        const requiredMessage = ERROR_MESSAGES.FILL_THE_FIELD;
       
    tempErrors.name = initialData.name.trim() ? '' : requiredMessage;
    tempErrors.description = initialData.description.trim() ? '' : requiredMessage;

        setErrors({
            ...tempErrors,
        });

        return tempErrors;
    };
    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setInitialData({
            ...initialData,
            [name]: value,
        });
    };
 const handleToggle = () => {
        setIsToggle((prevToggle) => !prevToggle);
        setInitialData({
            ...initialData,
            active: !isToggle,
        });
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        const tempErrors = validate();

        for (const key in tempErrors) {
            if (tempErrors[key]) {
                showMessage(
                    ERROR_MESSAGES.FILL_THE_FORM,
                    enqueueSnackbar,
                    'error',
                );
                return;
            }
        }

        const requestBody = Object.assign({}, initialData);

        sendJsonData(requestBody, submitUrl, isEdit)
            .then(() => {
                showMessage(SUCCESS_MESSAGES.ADDED_DATA, enqueueSnackbar);
                history.push(ROUTES_LIST.channelTypeList);
            })
            .catch((error) => {
                console.error("error",error);
                showMessage(
                    error.response?.data?.message
                        ? error.response.data.message
                        : ERROR_MESSAGES.REQUEST_FAIL,
                    enqueueSnackbar,
                    'error',
                );
            });
    };

    const handleDelete = () => {
        deleteData(submitUrl)
            .then(() => {
                showMessage(SUCCESS_MESSAGES.DELETED_DATA, enqueueSnackbar);
                history.push(ROUTES_LIST.channelTypeList);
            })
            .catch((error) => {
                console.error(error);
                showMessage(
                    error.response?.data?.message
                        ? error.response.data.message
                        : ERROR_MESSAGES.REQUEST_FAIL,
                    enqueueSnackbar,
                    'error',
                );
            });
    };
    
    return (
        <>
            <form onSubmit={handleSubmit} autoComplete="false">
                <Grid
                    container
                    direction="column"
                    spacing={2}
                    sx={{ width: '100%' }}
                >
                    <Grid
                        item
                        container
                        spacing={2}
                        direction="column"
                        sx={{ width: '100%' }}
                    >
                        <Grid item>
                            <TextField
                                value={initialData.name}
                                variant="standard"
                                label="Нэр"
                                fullWidth
                                name="name"
                                onChange={handleInputChange}
                                error={Boolean(errors.name)}
                                helperText={errors.name}
                            />
                        </Grid>
                        <Grid item>
                            <TextField
                                value={initialData.description}
                                variant="standard"
                                label="Тайлбар"
                                fullWidth
                                type="description"
                                name="description"
                                onChange={handleInputChange}
                                error={Boolean(errors.description)}
                                helperText={errors.description}
                            />
                        </Grid>
                        {/* <Grid item>
                            <TextField
                                select
                                value={initialData.vooChannelId}
                                variant="standard"
                                label="VOO Сувгууд"
                                fullWidth
                                name="vooChannelId"
                                onChange={handleInputChange}
                                error={Boolean(errors.vooChannelId)}
                                helperText={errors.vooChannelId}
                            >
                                {vooChannelList.map((channel) => (
                                    <MenuItem key={channel.id} value={channel.id}>
                                        {channel.name}
                                    </MenuItem>
                                ))}
                            </TextField>
                        </Grid>
                        <Grid item>
                            <TextField
                                select
                                value={initialData.channelTypeId}
                                variant="standard"
                                label="Сувгийн төрөл"
                                fullWidth
                                name="channelTypeId"
                                onChange={handleInputChange}
                                error={Boolean(errors.channelTypeId)}
                                helperText={errors.channelTypeId}
                            >
                                {channelTypeList.map((type) => (
                                    <MenuItem key={type.id} value={type.id}>
                                        {type.name}
                                    </MenuItem>
                                ))}
                            </TextField>
                        </Grid> */}

                        <Grid
                            item
                            container
                            direction="row"
                            justifyContent="space-between"
                        >
                            <Grid item>
                                <Button
                                    variant="contained"
                                    color="warning"
                                    type="button"
                                    onClick={() => history.goBack()}
                                >
                                    <ArrowBackIcon />
                                    <Typography style={{ marginLeft: '10px' }}>
                                        Буцах
                                    </Typography>
                                </Button>
                            </Grid>
                            <Grid item>
                                {/* {isEdit && (
                                    <Button
                                        variant="outlined"
                                        color="error"
                                        type="button"
                                        onClick={() =>
                                            setShowDeleteValidation(true)
                                        }
                                    >
                                        <DeleteOutlineIcon />
                                        <Typography
                                            style={{ marginLeft: '10px' }}
                                        >
                                            Устгах
                                        </Typography>
                                    </Button>
                                )} */}
                                Төлөв
                                 <Switch checked={initialData.active} onClick={handleToggle} />
                                <Button
                                    color="success"
                                    style={{ marginLeft: '10px' }}
                                    type="submit"
                                    variant="outlined"
                                >
                                    <SaveAltIcon />
                                    <Typography style={{ marginLeft: '10px' }}>
                                        Хадгалах
                                    </Typography>
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </form>

            {isEdit && (
                <Dialog
                    open={showDeleteValidation}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        Та энэхүү мэдээллийг устгахыг хүсэж байна уу?
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            Та энэ мэдээллийг устгахыг хүсэж байвал
                            &apos;Тийм&apos; товчийг дарна уу.
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setShowDeleteValidation(false)}>
                            Болих
                        </Button>
                        <Button color="error" onClick={handleDelete} autoFocus>
                            Тийм
                        </Button>
                    </DialogActions>
                </Dialog>
            )}
        </>
    );
}
